import { createFileRoute } from '@tanstack/react-router';
import { ReferenceDataManager } from '@/features/admin/ReferenceDataManager';

export const Route = createFileRoute('/admin/reference/titles')({
  component: TitlesAdmin,
});

function TitlesAdmin() {
  return (
    <ReferenceDataManager resource="titles" singular="title" />
  );
}
